import { render } from "./BreadcrumbPath.vue?vue&type=template&id=7878055b&scoped=true"
import script from "./BreadcrumbPath.vue?vue&type=script&lang=js"
export * from "./BreadcrumbPath.vue?vue&type=script&lang=js"

import "./BreadcrumbPath.vue?vue&type=style&index=0&id=7878055b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7878055b"

export default script